import { Chat } from '../entities/chat';
import type { ChatRole } from '../entities/chat';
import type { ToolExecutionDTO, SourceReferenceDTO } from './tool-execution.dto';

export interface CreateChatDTO {
  roomId: string;
  message: string;
  metadata?: Record<string, any>;
  isLoading?: boolean;
  sourceReferences?: SourceReferenceDTO[] | null;
  toolExecutions?: ToolExecutionDTO[] | null;
  toolMessages?: string[] | null;
  errorMessage?: string | null;
  changeProposalId?: string | null;
  mode?: 'chat' | 'edit' | 'compose';  // Chat mode selection
  currentDocumentId?: string;  // Current document ID for compose mode
}

export interface UpdateChatDTO {
  message?: string;
  metadata?: Record<string, any>;
  isLoading?: boolean;
  sourceReferences?: SourceReferenceDTO[] | null;
  toolExecutions?: ToolExecutionDTO[] | null;
  toolMessages?: string[] | null;
  errorMessage?: string | null;
  changeProposalId?: string | null;
}

export interface ChatDTO {
  id: string;
  roomId: string;
  userId: string | null;
  role: ChatRole;
  message: string;
  metadata: Record<string, any> | null;
  isLoading: boolean;
  sourceReferences: SourceReferenceDTO[] | null;
  toolExecutions: ToolExecutionDTO[] | null;
  toolMessages: string[] | null;
  errorMessage: string | null;
  changeProposalId: string | null;
  createdAt: Date;
  updatedAt: Date;
}

export class ChatMapper {
  static toDTO(chat: Chat): ChatDTO {
    return {
      id: chat.id,
      roomId: chat.room_id,
      userId: chat.user_id,
      role: chat.role,
      message: chat.message,
      metadata: chat.metadata,
      isLoading: chat.is_loading,
      sourceReferences: chat.source_references,
      toolExecutions: chat.tool_executions,
      toolMessages: chat.tool_messages,
      errorMessage: chat.error_message,
      changeProposalId: chat.change_proposal_id,
      createdAt: chat.created_at,
      updatedAt: chat.updated_at
    };
  }
}